var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-8"},[(!_vm.isResultSaved)?_c('ImportantData'):_vm._e(),(_vm.isResultSaved)?_c('SavedImportantData'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }